import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import PhoneTypeService from "../../../Services/PhoneType.service";
const makeSearchArgs = {
    loadOptions: (search, options) => PhoneTypeService.search(Object.assign(Object.assign({}, options), { searchText: search })).then(({ data }) => data),
    label: "srcSystemName",
    value: "id",
};
export const PhoneTypeSearch = makeSearch(makeSearchArgs);
export const PhoneTypeMultiSearch = makeMultiSearch(Object.assign({}, makeSearchArgs));
